/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react'
import _ from 'lodash'
import { Button } from 'semantic-ui-react'
import moment from 'moment'

import firebase from '../../../config/firebase'

class FinanceMonthlyReport extends React.Component {
  fileReader = new FileReader()
  fileInputRef = React.createRef()
  downloadLinkRef = React.createRef()

  state = {
    downloading: false,
    downloadUrl: '',
  }

  onDownloadClick = async () => {
    const { headers, orders } = this.props
    const csvString = await this.generateCSV(headers, orders)

    const snapshot = await this.uploadFile(csvString)
    this.downloadFile(snapshot)
  }

  onClearFile = () => {
    this.fileReader.abort()
    this.fileInputRef.value = ''
  }

  generateCSV = async (headers, orders) => {
    let csvString = ''

    csvString = csvString.concat(`${headers} \n`)

    const orderLength = orders.length

    for (let i = 0; i < orderLength; i += 1) {
      const rowString = orders[i].map(col => String(col).replace(',', ' '))
      csvString = csvString.concat(`${rowString.join(', ')} \n`)
    }

    return csvString
  }

  onReadFile = () => {
    const self = this

    this.fileReader.onload = event => {
      const ordersFromJson = JSON.parse(event.target.result)
      self.props.getOrderByDateSuccess(ordersFromJson)
      self.onClearFile()
    }

    this.fileReader.onloadstart = () => {
      self.setState({ uploading: true })
    }
    this.fileReader.onloadend = () => {
      self.setState({ uploading: false })
    }
  }

  onFileChange = e => {
    const file = e.target.files[0]

    if (file) {
      this.onReadFile()
      this.fileReader.readAsText(file)
    }
  }

  uploadFile = async csvString => {
    const { startFrom, endAt } = this.props
    const startFromFormat = moment(startFrom).format('YYYY-MMM-DD')
    const endAtFormat = moment(endAt).format('YYYY-MMM-DD')
    const storage = firebase
      .storage()
      .ref()
      .child(`report/finance-monthly-report-${startFromFormat}-to-${endAtFormat}.csv`)

    this.setState({ downloading: true })

    return storage.putString(csvString.toString())
  }

  downloadFile = snapshot => {
    const self = this
    snapshot.ref.getDownloadURL().then(downloadUrl => {
      self.setState({ downloading: false, downloadUrl }, () => {
        self.downloadLinkRef.click()
      })
    })
  }

  render() {
    const { downloading, downloadUrl } = this.state
    const { orders } = this.props

    return (
      <div style={{ display: 'inline' }}>
        <Button
          disabled={downloading || _.size(orders) === 0}
          loading={downloading}
          onClick={this.onDownloadClick}
        >
          Download Report
        </Button>
        <a
          href={downloadUrl}
          ref={ref => {
            this.downloadLinkRef = ref
          }}
          style={{ display: 'none' }}
        />
        <input
          type="file"
          accept=".csv"
          hidden
          ref={ref => {
            this.fileInputRef = ref
          }}
          onChange={this.onFileChange}
        />
      </div>
    )
  }
}

export default FinanceMonthlyReport



// WEBPACK FOOTER //
// ./src/containers/reports/components/SaleReportSheet.js